import { makeAutoObservable } from 'mobx';

import useStore from '@/common/hooks/useStore';

class ModalStore {
  openedModalsIds: string[] = [];

  constructor() {
    makeAutoObservable(this, {
      isTopModal: false,
    });
  }

  get hasOpenedModals(): boolean {
    return this.openedModalsIds.length > 0;
  }

  private get topModalId(): Nullable<string> {
    if (this.openedModalsIds.length === 0) {
      return null;
    }

    return this.openedModalsIds[this.openedModalsIds.length - 1];
  }

  addOpenModalId = (id: string): void => {
    this.openedModalsIds.push(id);
  };

  removeOpenModalId = (id: string): void => {
    this.openedModalsIds = this.openedModalsIds.filter((modalId) => modalId !== id);
  };

  isTopModal = (id: string): boolean => {
    return this.topModalId === id;
  };
}

export const useModalStore = () => useStore(ModalStore);

export const modalStore = new ModalStore();
export default ModalStore;
